import { useState } from 'react'
import { useIntl } from 'react-intl'
import { mdiPlus } from '@mdi/js'

import ProfileUploadModal from './ProfileUploadModal'
import SuccessModal from 'components/Modal/SuccessModal'
import { commonMessages } from 'app/i18n/messages'
import { RegularModerate } from 'components/Typography'
import { profilesPageMessages } from 'features/profiles/messages'
import {
  ProfileIcon,
  UploadProfileDesktopButton,
  UploadProfileMobileButton,
} from './styles'

function ProfileUploadButton() {
  const { formatMessage } = useIntl()
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isUploadSuccessModalOpen, setIsUploadSuccessModalOpen] =
    useState(false)
  const [uploadedFilename, setUploadedFilename] = useState('')
  return (
    <>
      <UploadProfileDesktopButton
        type="button"
        variant="secondary"
        onClick={() => setIsUploadModalOpen(true)}
      >
        {formatMessage(profilesPageMessages.uploadProfileButtonLabel)}
      </UploadProfileDesktopButton>

      <UploadProfileMobileButton onClick={() => setIsUploadModalOpen(true)}>
        <ProfileIcon path={mdiPlus} size={1} />
      </UploadProfileMobileButton>

      {isUploadModalOpen && (
        <ProfileUploadModal
          isOpen
          setUploadedFilename={setUploadedFilename}
          onSuccess={() => setIsUploadSuccessModalOpen(true)}
          handleClose={() => setIsUploadModalOpen(false)}
        />
      )}

      {isUploadSuccessModalOpen && (
        <SuccessModal
          isOpen
          confirmBtnTitle={formatMessage(commonMessages.done)}
          title={formatMessage(commonMessages.success)}
          onConfirm={() => setIsUploadSuccessModalOpen(false)}
        >
          <RegularModerate>
            {formatMessage(profilesPageMessages.uploadedSuccessModalMessage, {
              uploadedFilename,
              b: (...chunks) => <b>{chunks}</b>,
            })}
          </RegularModerate>
        </SuccessModal>
      )}
    </>
  )
}

export default ProfileUploadButton
